import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationHelperService {

  constructor() { }

   /**
   * Generate pagination array dynamically based on current page and total pages.
   * @param currentPage The current page number
   * @param totalPages The total number of pages
   * @returns An array of page numbers to display
   */
  generatePageArray(currentPage: number, totalPages: number): number[] {
    const pages: number[] = [];

    if (currentPage === 1) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } 
    else if (currentPage === totalPages) {
      for (let i = Math.max(1, totalPages - 2); i <= totalPages; i++) {
        pages.push(i);
      }
    } 
    else if (currentPage % 1 === 0) { 
      for (let i = currentPage; i <= totalPages; i++) {
        pages.push(i);
      }
    } 
    else {
      for (let i = Math.max(1, currentPage - 1); i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return pages;
  }


  toggleSort(currentColumn: string, currentType: 'ASC' | 'DESC', newColumn: string, newType: 'ASC' | 'DESC') {
    let column = currentColumn;
    let type = currentType;

    // If clicking a new column
    if (newColumn !== currentColumn) {
      column = newColumn;
      type = newType;
    } 
    // If clicking the same column
    else {
      // Toggle between ASC and DESC
      type = currentType === 'ASC' ? 'DESC' : 'ASC';
    }

    return { column, type };
  }
}
